module.exports = __webpack_public_path__ + "static/media/whatsapp.64955b28.png";